import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface Notification {
  message: string;
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationSubject = new Subject<Notification>();
  notifications$: Observable<Notification> = this.notificationSubject.asObservable();

  showNotification(message: string, duration: number = 5000): void {
    this.notificationSubject.next({ message, duration });
    console.log('NotificationService | showNotification() | Notification sent:', message);
  }
}